// Decorate Shopify's native banner without changing consent or replacing its controls.
(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('fr')) return;
  const decorate = () => {
    const body = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body');
    if (!body || body.querySelector('.lcdm-consent-intro')) return;
    const intro = document.createElement('div');
    intro.className = 'lcdm-consent-intro';
    const bike = document.createElement('span');
    bike.className = 'lcdm-consent-bike';
    bike.setAttribute('aria-hidden', 'true');
    bike.textContent = '🏍️';
    const slogan = document.createElement('p');
    slogan.className = 'lcdm-consent-slogan';
    slogan.textContent = 'On prend la route ensemble ?';
    intro.append(bike, slogan);
    body.prepend(intro);
  };
  decorate();
  // Shopify can inject or rebuild the banner after page load or preference changes.
  const observer = new MutationObserver((records) => {
    if (records.some((record) => record.addedNodes.length)) decorate();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
